import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { NgIdleModule } from '@ng-idle/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './core/services';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyModule } from '@ngx-formly/core';
import { AppState, InternalStateType } from './app.service';
import { EmitService } from './ts/services/emit.service';
import { AuthGuard } from './core/guards/auth.guard';
import { JoyrideModule } from 'ngx-joyride';
import { VersionCheckService } from "@app/shared/versioncheck/version-check.service";

// Application wide providers
const APP_PROVIDERS = [
  AppState
];

@NgModule({
  declarations: [
    AppComponent,   
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    CoreModule,
    FormlyBootstrapModule,
    FormlyModule.forRoot(),
    NgIdleModule.forRoot(),
    JoyrideModule.forRoot()
  ],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },AppState,EmitService,AuthGuard,VersionCheckService],
  bootstrap: [AppComponent]
})
export class AppModule { }
